/**
 * PDI Loyalty International API v1.5.20
 * Note: All dates/times returned via API call will be UTC / Accept-Encoding: gzip, deflate<br><br><a href='https://pditechnologies.com/engage-customers/loyalty-marketing-solutions/'>PDI Technologies website</a><br><a href='mailto:azpiral-info@pditechnologies.com?subject=AzpiralAPI'>Send an email to PDI Technologies</a><br><a href='../../Contents/FlowDiagrams/Index.htm'>Flow Diagrams</a><br><a href='../../v1/Helpers/ApiErrors/'>Error Codes</a>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AccessIdentifierRequest model module.
 * @module model/AccessIdentifierRequest
 * @version v1
 */
class AccessIdentifierRequest {
    /**
     * Constructs a new <code>AccessIdentifierRequest</code>.
     * @alias module:model/AccessIdentifierRequest
     * @param URL {String} MaxLength:2048
     * @param permissionShared {Boolean} 
     */
    constructor(URL, permissionShared) { 
        
        AccessIdentifierRequest.initialize(this, URL, permissionShared);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, URL, permissionShared) { 
        obj['URL'] = URL;
        obj['PermissionShared'] = permissionShared;
    }

    /**
     * Constructs a <code>AccessIdentifierRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccessIdentifierRequest} obj Optional instance to populate.
     * @return {module:model/AccessIdentifierRequest} The populated <code>AccessIdentifierRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccessIdentifierRequest();

            if (data.hasOwnProperty('URL')) {
                obj['URL'] = ApiClient.convertToType(data['URL'], 'String');
            }
            if (data.hasOwnProperty('PermissionShared')) {
                obj['PermissionShared'] = ApiClient.convertToType(data['PermissionShared'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccessIdentifierRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccessIdentifierRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of AccessIdentifierRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['URL'] && !(typeof data['URL'] === 'string' || data['URL'] instanceof String)) {
            throw new Error("Expected the field `URL` to be a primitive type in the JSON string but got " + data['URL']);
        }

        return true;
    }


}

AccessIdentifierRequest.RequiredProperties = ["URL", "PermissionShared"];

/**
 * MaxLength:2048
 * @member {String} URL
 */
AccessIdentifierRequest.prototype['URL'] = undefined;

/**
 * @member {Boolean} PermissionShared
 */
AccessIdentifierRequest.prototype['PermissionShared'] = undefined;






export default AccessIdentifierRequest;

